import { auth } from "./auth";
import { commons } from "./commons";
import { database } from "./database";
import { establishment } from "./establishment";
import { orders } from "./orders";
import { payments } from "./payments";
import { staff_tracking } from "./staff_tracking";

export const nlNL = {
  auth,
  commons,
  database,
  establishment,
  orders,
  payments,
  staff_tracking,
};
